import { Preloader } from 'components';
// import { FullScreenCenteredContainer } from 'components/Common.styled';
import { useAuth } from 'hooks';
import React, { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { routes } from 'routes';
import { getLocationHistory, removeLocationHistory } from 'utils';

export const NotFound: FC = () => {
    const history = useHistory();
    const {
        state: { authenticated },
    } = useAuth();

    useEffect(() => {
        if (authenticated) {
            if (getLocationHistory()) {
                history.push(getLocationHistory());
                removeLocationHistory();
            } else {
                history.push(routes.home);
            }
        } else {
            if (getLocationHistory()) {
                history.push(getLocationHistory());
                removeLocationHistory();
            } else {
                history.push(routes.login);
            }
        }
    }, [authenticated, history]);
    return (
        <Preloader />
        // <FullScreenCenteredContainer>
        //     <p>404 | This page doesn't exist</p>
        // </FullScreenCenteredContainer>
    );
};
